import { AlertCircle } from "lucide-react";
import { Card, CardContent } from "../ui/Card";
import { Button } from "../ui/Button";

export default function PageNotFound() {

  return (
    <div className="container mx-auto px-6 py-8">
      <Card>
        <CardContent>
            <div className="flex flex-col items-center justify-center h-full space-y-6 py-12">
                <div className="flex justify-center">
                    <div className="rounded-full bg-destructive/10 p-3">
                        <AlertCircle className="h-12 w-12 text-destructive" />
                    </div>
                </div>
                
                <div className="space-y-2">
                <h1 className="text-2xl font-bold text-foreground text-center">
                    Page Not Found
                </h1>
                <p className="text-sm text-muted-foreground text-center">
                  Oops.. looks like the page you are trying to access does not exist or you do not have permission to view it.
                </p>
                </div>

                <Button className="m-5" variant="outline" onClick={() => window.history.back()}>
                  Go Back
                </Button>
            </div>
        </CardContent>
    </Card>
    </div>
    
  );
}